import { InstrumentChartModel } from '@zero/shared/util-models';
import { DepotChartSerie } from '@zero/statistics/domain';

export abstract class ChartService {
  public abstract setupChart(container: HTMLElement, options: Partial<unknown>): void;
  public abstract initChart(model: InstrumentChartModel): void;
  public abstract updateChart(model: InstrumentChartModel): void;
  public abstract changeChartType(model: InstrumentChartModel, type: string): void;
  public abstract setupMyChart(container: HTMLElement): void;
  public abstract initMyChart(chartWithoutCash: DepotChartSerie[], chartWithCash: DepotChartSerie[]): void;
  public abstract toggleCashLine(withCash: boolean, chartWithCash: DepotChartSerie[]): void;
}
